<template>
  <el-container v-loading="loading" id="top" style="height:969px;">
    <el-header>
      <HeaderView :userName="viewUserName" @calcHeaderSpace="calcHeaderSpace" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="height:100%;overflow:auto;">
        <el-row style="width:100%;">
          <bull-dialog :bullId="''" :farmerId="farmer_id" :edit="false" :bullData="bulls" :modeDialog="false"
            :headerWidth="headerWidth" />
        </el-row>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import BullDialog from '../components/BullDialog';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from './js/const';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

export default {
  name: 'SettingView',
  components: {
    HeaderView,
    MenuView,
    BullDialog
  },
  created() {
    this.$store.commit('setCowMenuSelect', '> 種雄牛');
  },
  mounted() {
    this.restore_param();
    this.get_current_user();
  },
  data() {
    return {
      userType: ConstParam.disable_user_kind,
      headerWidth: "96px",
      pregnancy_term: ConstParam.pregnancy_term,
      farmer_env: false,
      save_index: 0,
      start_time: "",
      end_time: "",
      message: "",
      dialogVisible: false,
      amnion: "ON",
      amnion_time: 5,
      calf_leg: "ON",
      calf_leg_time: 5,
      tail_up: "ON",
      tail_up_time: 5,
      move_length: "ON",
      move_length_time: 5,
      kicking: "ON",
      kicking_time: 5,
      preyon: "ON",
      preyon_time: 5,
      posture: "ON",
      posture_time: 5,
      select_times: ConstParam.select_times,
      tableData: [
        {
          start: "",
          end: ""
        }
      ],
      feeding_times: [],
      bulls: [],
      tableBulls: [],
      eggs: [],
      tableEggs: [],
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: true,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    }
  },
  methods: {
    calcHeaderSpace(spacesize) {
      this.headerWidth = spacesize;
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
    // ==================
  },
  watch: {
    // ===== 以降固定 ====
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      this.feeding_times = [];
      if ('farmer' in this.userData && 'feeding_times' in this.userData['farmer']) {
        this.feeding_times = this.userData['farmer']['feeding_times'];
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      // アラート抑止
      this.amnion = false;
      this.calf_leg = false;
      this.tail_up = false;
      this.move_length = false;
      this.kicking = false;
      this.preyon = false;
      this.posture = false;
      if ("alert_notification" in this.userData && this.userData['alert_notification']) {
        this.amnion = (this.userData['alert_notification']['amnion'] ? 'ON' : 'OFF');
        this.calf_leg = (this.userData['alert_notification']['calf_leg'] ? 'ON' : 'OFF');
        this.tail_up = (this.userData['alert_notification']['tail_up'] ? 'ON' : 'OFF');
        this.move_length = (this.userData['alert_notification']['move_length'] ? 'ON' : 'OFF');
        this.kicking = (this.userData['alert_notification']['kicking'] ? 'ON' : 'OFF');
        this.preyon = (this.userData['alert_notification']['amount_of_prey'] ? 'ON' : 'OFF');
        this.posture = (this.userData['alert_notification']['posture_change'] ? 'ON' : 'OFF');
      }
      this.amnion_time = 5;
      this.calf_leg_time = 5;
      this.tail_up_time = 5;
      this.move_length_time = 5;
      this.kicking_time = 5;
      this.preyon_time = 5;
      this.posture_time = 5;
      if ("alert_supression_time" in this.userData && this.userData['alert_supression_time']) {
        this.amnion_time = this.userData['alert_supression_time']['amnion'];
        this.calf_leg_time = this.userData['alert_supression_time']['calf_leg'];
        this.tail_up_time = this.userData['alert_supression_time']['tail_up'];
        this.move_length_time = this.userData['alert_supression_time']['move_length'];
        this.kicking_time = this.userData['alert_supression_time']['kicking'];
        this.preyon_time = this.userData['alert_supression_time']['amount_of_prey'];
        this.posture_time = this.userData['alert_supression_time']['posture_change'];
      }
      // 餌やり時間
      let tempTable = [];
      for (let idx = 0; idx < this.feeding_times.length; idx++) {
        let tempParam = this.feeding_times[idx].split('/');
        let tempData = {
          start: tempParam[0],
          end: tempParam[1],
          feed_time: tempParam[0] + "～" + tempParam[1]
        }
        tempTable.push(tempData);
      }
      this.tableData = tempTable;
      // 種雄牛
      if ("bulls" in this.userData['farmer']) {
        this.bulls = this.userData['farmer']['bulls'];
      }
      // 受精卵
      if ("eggs" in this.userData['farmer']) {
        this.eggs = this.userData['farmer']['eggs'];
      }
      this.loading = false;
    }
    // ==================
  }
}
</script>

<style scoped>
div,
span {
  color: #383838;
}
</style>